import { render } from "./MfpPopup.vue?vue&type=template&id=c4273f7a&scoped=true"
import script from "./MfpPopup.vue?vue&type=script&lang=js"
export * from "./MfpPopup.vue?vue&type=script&lang=js"

import "./MfpPopup.vue?vue&type=style&index=0&id=c4273f7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4273f7a"]])

export default __exports__